"use client";
import { useTheme } from "@/components/theme-provider";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react";

export const HeroSection = () => {
  const { theme } = useTheme();

  const container = useRef();

  useGSAP(
    () => {
      gsap.from("#features", {
        x: -100,
        y: 100,
        scale: 1.2,
        duration:1,
        ease:'bounce.inOut'
      });
    },
    { scope: container }
  );

  return (
    <section className="container w-full overflow-x-hidden" id="home">
      <div
        className="grid place-items-center lg:max-w-screen-xl gap-8 mx-auto py-20 md:py-32"
        ref={container}
      >
        <div className="text-center space-y-8">
          <Badge variant="outline" className="text-sm py-2" id="features">
            <span className="mr-2 text-primary">
              <Badge>New</Badge>
            </span>
            <span> Features are out now! </span>
          </Badge>

          <div className="max-w-screen-md mx-auto text-center text-4xl md:text-6xl font-bold">
            <h1>
              Revolutionize Your
              <span className="text-transparent px-2 bg-gradient-to-r from-secondary to-primary bg-clip-text">
                Car Wash Business
              </span>
              with Our All-in-One
              <span className="text-transparent px-2 bg-gradient-to-r from-secondary to-primary bg-clip-text">
                POS
              </span>{" "}
              Solution
            </h1>
          </div>

          <p className="max-w-screen-sm mx-auto text-xl text-muted-foreground">
            {`Manage orders, streamline operations, track reports and boost customer satisfaction with ease`}
          </p>

          <div className="space-y-4 md:space-y-0 md:space-x-4">
            <Link to="/app/dashboard">
              <Button className="w-5/6 md:w-1/4 font-bold group/arrow">
                Get Started
                <ArrowRight className="size-5 ml-2 group-hover/arrow:translate-x-1 transition-transform" />
              </Button>
            </Link>

            <Button
              asChild
              variant="secondary"
              className="w-5/6 md:w-1/4 font-bold"
            >
              <Link
                to="/#contact"
                onClick={() =>
                  document
                    .querySelector("/#contact")
                    ?.scrollIntoView({ behavior: "smooth", block: "start" })
                }
              >
                Contact Us
              </Link>
            </Button>
          </div>
        </div>

        <div className="relative group mt-14">
          <div className="absolute top-2 lg:-top-8 left-1/2 transform -translate-x-1/2 w-[90%] mx-auto h-24 lg:h-80 bg-primary/50 rounded-full blur-3xl"></div>
          <img
            className="w-full md:w-[1200px] mx-auto rounded-lg relative rouded-lg leading-none flex items-center border border-t-2 border-secondary  border-t-primary/30"
            src={
              theme === "light"
                ? "/hero-image-light.png"
                : "/hero-image-dark.png"
            }
            alt="dashboard"
          />

          <div className="absolute bottom-0 left-0 w-full h-20 md:h-28 bg-gradient-to-b from-background/0 via-background/50 to-background rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};
